import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter1() {
  const hyperlinkData = [
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/nova-scotia/',
      copy: 'Kia Damon',
      label: 'Visit Episode One, Explore Nova Scotia with Kia Damon'
    },
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/ontario/',
      copy: 'Trevor Wallace',
      label: 'Visit Episode two, Explore Ontario with Trevor Wallace'
    },
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
      copy: 'here',
      label: 'Visit This is Canada hub page'
    },
    {
      href: 'https://destinationindigenous.ca/',
      copy: 'Indigenous tourism',
      label: 'Visit Destination Indigenous page'
    },
    {
      href: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/british-columbia/',
      copy: 'Wesley Hamilton',
      label: 'Visit Episode Three, Explore British Columbia with Wesley Hamilton'
    }
  ];
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        When award-winning chef <Hyperlink hyperlinkData={hyperlinkData[0]} />, filmmaker{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} />, and adaptive rights advocate{' '}
        <Hyperlink hyperlinkData={hyperlinkData[4]} /> traveled north to find renewal, reconnection,
        and revelation in Canada, they discovered a country with the power to refresh their
        perspectives and rekindle their spirits.
      </p>
      <p className="chapter__paragraph">
        (Follow their journeys on film <Hyperlink hyperlinkData={hyperlinkData[2]} />
        .)
      </p>
      <p className="chapter__paragraph">
        Spanning 3.8 million square miles from coast to coast to coast, Canada is a country so large
        there’s endless potential to discover its diverse landscapes, cultures, and activities. Our
        film series captures some of the country’s best highlights, but with so many itineraries and
        ideas to choose from, it’s a place you’re going to want to come back to again and again.
      </p>
      <p className="chapter__paragraph">
        There’s Québec City, a historic provincial capital with an unrivaled food scene rooted in
        French culture. In Alberta and British Columbia, the show-stopping beauty of the Rockies
        inspires with its shimmering glacial lakes and rugged landscapes. The remote Yukon
        wilderness practically begs for a digital detox with its soaring peaks, expansive vistas,
        and unforgettable wildlife.
      </p>
      <p className="chapter__paragraph">
        And all across Canada, there are many opportunities to support{' '}
        <Hyperlink hyperlinkData={hyperlinkData[3]} /> and learn about the diversity of over 630
        Indigenous communities. (The name “Canada” comes from the Huron-Iroquois word for “village,”
        kanata.)
      </p>
      <p className="chapter__paragraph">
        Read on to discover even more of Canada’s most impressive destinations.
      </p>
    </section>
  );
}

export default Chapter1;
